import historyDefault from '../history';

export const SHIPMENTS_OPEN_BATCHES_PATH = '/shipments/batches/open';

export const BatchTabOption = {
  OPEN: 'open',
  PROCESSED: 'processed',
  ARCHIVED: 'archived',
  ADVANCED_SEARCH: 'advanced-search',
};

export const getTabFilterFromPathName = (history = historyDefault) => {
  const pathName = history.location.pathname;
  const expectedTabFilterOptions = [BatchTabOption.OPEN, BatchTabOption.PROCESSED, BatchTabOption.ARCHIVED, BatchTabOption.ADVANCED_SEARCH];
  const foundTabFilter = pathName
    .split('/')
    .reverse()
    .filter((subPath) => Number.isNaN(parseInt(subPath, 10)))[0];
  const batchIdRegEx = new RegExp('([0-9]{5,})', 'g');
  if (expectedTabFilterOptions.includes(foundTabFilter) && !batchIdRegEx.test(pathName)) {
    return foundTabFilter;
  }
  return '';
};
